export default "__VITE_ASSET__CnK7tCgs__"